import { render, staticRenderFns } from "./nonStructural.vue?vue&type=template&id=1e90ac46&scoped=true"
import script from "./nonStructural.vue?vue&type=script&lang=js"
export * from "./nonStructural.vue?vue&type=script&lang=js"
import style0 from "./nonStructural.vue?vue&type=style&index=0&id=1e90ac46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90ac46",
  null
  
)

export default component.exports